<script>
  import RangeGroup from "./RangeGroup.svelte"

  export let quantityValue
  export let initialPricePhase
  export let expectedPriceValue
</script>

<form class="flex flex-col items-stretch justify-between size-full gap-y-10">
  <RangeGroup label="Quantity" unit="in 1.000 $PLAYR" name="quantity" bind:value={quantityValue} min="0" max="1000" step="10" />
  <RangeGroup label="Initial Price" unit="in €" name="initial" bind:value={initialPricePhase} min="0" max="2" step="1" altValues={true} altValuesArray={[0.001, 0.003, 0.005]} />
  <RangeGroup label="Expected Value" unit="in €" name="expected" bind:value={expectedPriceValue} min="0.05" max="0.5" step="0.01" />
</form>
